<template>
  <div>
    <mdb-tbl hover sm>
      <mdb-tbl-head>
        <tr class="title" >
          <th style="width:40px">No</th>
          <th>제목</th>
          <th style="width:80px">작성자</th>
          <th style="width:80px">조회수</th>
          <th style="width:100px">등록일</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(article, index) in articles" :key="index">
          <td>{{startIndex - index}}</td>
          <td><span class="pointer" @click="onSelect(article._id)">{{article.title}}</span></td>
          <td>{{article.writer.name}}</td>
          <td>{{article.readCount}}</td>
          <td>{{$moment(article.regDate).format('YYYY-MM-DD')}}</td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue';
export default {
  name: 'article-list',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['articles', 'startIndex'],
  methods: {
    onSelect (_id) {
      this.$emit('select', _id);
    }
  }
}
</script>

<style scoped>
th {
  font-weight: bolder;
}
</style>
